import $ from 'jquery';
import device from 'current-device';
import Foundation from './3rd/_zf.js';

import './utils/global.js';
import './utils/back-to-top.js';
import './utils/script-loader.js';
import {initMenu} from './utils/menu.js';

import {initSocialShare} from './components/social-share.js';

// Styles
import '../styles/3rd/_index.scss';

// DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
    initMenu('#main-nav', '.main-nav');
    initSocialShare('[data-social-share]', {
        intents: [
            'facebook',
            'x',
            'print',
            'send-email',
            'copy-link',
            'web-share'
        ]
    });

    //
    // YITH filter
    //
    const wrapper = document.querySelector('.yith-wcan-filters');
    if (wrapper) {
        const observer = new MutationObserver((mutations) => {
            for (let mutation of mutations) {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    initMenu('#main-nav', '.main-nav');
                    break;
                }
            }
        });
        observer.observe(wrapper, {childList: true, subtree: true});
    }

    //
    // toggle menu footer
    //
    document.querySelectorAll("#footer-columns .footer-title").forEach(link => {
        link.addEventListener("click", function (event) {
            event.preventDefault();
            this.classList.toggle("active");
        });
    });

    //
    // product attributes
    //
    const MIN_WIDTH = 250;
    const widgets = document.querySelectorAll('.product-attributes .widget_layered_nav');

    function adjustDropdown(widget) {
        const dropdown = widget.querySelector('ul');
        if (!dropdown) return;

        const toggleElem = widget.querySelector('span') || widget;
        const rect = toggleElem.getBoundingClientRect();
        const spaceRight = window.innerWidth - rect.right;

        if (spaceRight < MIN_WIDTH) {
            dropdown.classList.add('align-right');
        } else {
            dropdown.classList.remove('align-right');
        }
    }

    function closeAll() {
        widgets.forEach(el => el.classList.remove('active'));
    }

    widgets.forEach(widget => {
        widget.addEventListener('click', e => {
            if (e.target.closest('ul')) return;

            e.preventDefault();
            const isActive = widget.classList.contains('active');

            closeAll();

            if (!isActive) {
                widget.classList.add('active');
                adjustDropdown(widget);
            }
        });
    });

    window.addEventListener('resize', () => {
        const openWidget = document.querySelector('.product-attributes .widget_layered_nav.active');
        if (openWidget) adjustDropdown(openWidget);
    });
});
